




























import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import { CardSelectItem } from './types';
const name = 'ttam-card-select';

export default defineComponent({
  name,
  props: {
    data: {
      type: Array as PropType<CardSelectItem[]>,
      required: true,
    },
    itemWidth: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      required: true,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { data } = toRefs(props);

    const itemStyle = computed(() =>
      props.itemWidth
        ? {
            'flex-basis': props.itemWidth,
          }
        : {},
    );
    const colSpan = computed(() => {
      // 根据有多少列，计算col的span，例如有3列，每列占8
      const colLen = data.value.filter(({ hide }) => !hide)?.length;
      const spanMap = {
        1: 12, // 1列
        2: 12, // 2列
        3: 8, // 3列
      };
      return spanMap[colLen] as number;
    });
    const onClick = (i: typeof props.data['0']) => {
      if (!props.disabled && !i.disabled) {
        emit('input', i.id);
        emit('change-item', i);
      }
    };
    return {
      name,
      itemStyle,
      onClick,
      colSpan,
    };
  },
});
